// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__19GZ2","header":"Messages_header__2nD3n"};